define('lq/events/actions/activeDirectorySyncGroupUsers',['lq/events/actions/eventAction'],
    function (EventAction) {
        'use strict';

        function ActiveDirectorySyncGroupUsers(eventData, eventArg) {
            EventAction.call(this, eventData, eventArg);
            return this;
        }

        EventAction.extend(ActiveDirectorySyncGroupUsers, EventAction);

        ActiveDirectorySyncGroupUsers.typeName = 'ActiveDirectorySyncGroupUsers';

        ActiveDirectorySyncGroupUsers.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

        ActiveDirectorySyncGroupUsers.prototype.createEventActionRequest = function () {
            var self = this;
            return {
                eventActionType: "ActiveDirectorySyncGroupUsers",
                command: self.eventData.command
            };
        };

        ActiveDirectorySyncGroupUsers.prototype.execute = function (continuation, eventActionResponse) {
            continuation();
        };

        return ActiveDirectorySyncGroupUsers;
    }
);
